import { render, staticRenderFns } from "./workTemplate.vue?vue&type=template&id=8af5a0c2&scoped=true&"
import script from "./workTemplate.vue?vue&type=script&lang=js&"
export * from "./workTemplate.vue?vue&type=script&lang=js&"
import style0 from "./workTemplate.vue?vue&type=style&index=0&id=8af5a0c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af5a0c2",
  null
  
)

export default component.exports